import { createSlice } from '@reduxjs/toolkit';
import type React from 'react';
import { useEffect, useState } from 'react';

import { xhr } from '@shared/config';
import { useAppDispatch, useAppSelector } from '@shared/hooks';

interface TimezoneGeo {
	timezone: string;
	geo: {
		country: string;
		state: string;
	};
}

const initialState = {
	tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

const timezone = createSlice({
	name: 'timezone',
	initialState,
	reducers: {
		setTz: (state, action) => {
			state.tz = action.payload;
		},
	},
});

const selectTz = (state: RootState) => state.schedule.timezone.tz;

export const tzReducer = timezone.reducer;

const { setTz } = timezone.actions;

export const useTz = () => {
	const dispatch = useAppDispatch();
	const tz = useAppSelector(selectTz);

	const setTimezone = (timezone: string) => dispatch(setTz(timezone));

	return {
		tz,
		setTimezone,
	};
};

export const useTimezoneLoader = () => {
	const [search, setSearch] = useState('');
	const [geo, setGeo] = useState<TimezoneGeo>();

	useEffect(() => {
		const controller = new AbortController();

		const loadTimezoneList = async () => {
			if (!search || search.length < 3) return;

			try {
				const res = await xhr.post<TimezoneGeo>(
					`/api/v1/common/timezones/city/`,
					{ location: search },
					{ signal: controller.signal }
				);

				setGeo(res.data);
			} catch (error) {
				// console.log(error);
			}
		};

		loadTimezoneList();
		return () => {
			controller.abort();
		};
	}, [search]);

	const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value);

	return {
		onSearch,
		search,
		geo,
	};
};
